var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-secondary align-self-center mr-2",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.exportData}},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":['fad', 'file-export']}}),_vm._v(_vm._s(_vm.$t("generelleEinstellungenHersteller.herstellerExportieren"))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }